module.exports = __webpack_public_path__ + "media/advantage/handShake-f9da6c1f.jpg";